import { useEffect, useState } from "react";

function BackToTop() {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    const handleScrollButtonVisibility = () => {
      if (window.scrollY > 10) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    };

    window.addEventListener("scroll", handleScrollButtonVisibility);

    return () => {
      window.removeEventListener("scroll", handleScrollButtonVisibility);
    };
  }, []);

  return (
    <div
      className={
        showButton
          ? "old-footer-back-to-top is-visible"
          : "old-footer-back-to-top"
      }
    >
      <a href="#top" className="old-footer-back-to-top-link" aria-label="back-to-top">
        <div className="old-footer-back-to-top-icon">
            <i className="bi bi-chevron-up old-footer-back-to-top-icon"></i>
        </div>
      </a>
    </div>
  );
}

export default BackToTop;
